import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { UserListComponent } from './main/pages/users/user-list/user-list.component';
import { CreateEditUserComponent } from './main/pages/users/create-edit-user/create-edit-user.component';
import { OrganizationListComponent } from './main/pages/organizations/organization-list/organization-list.component';
import { CreateEditOrganizationComponent } from './main/pages/organizations/create-edit-organization/create-edit-organization.component';
import { DashboarMainComponent } from './main/pages/dashboard/dashboar-main/dashboar-main.component';
import { PushNotificationsComponent } from './main/pages/notification-contents/push-notifications/push-notifications.component';
import { EmailNotificationsComponent } from './main/pages/notification-contents/email-notifications/email-notifications.component';
import { SystemNotificationsComponent } from './main/pages/notification-contents/system-notifications/system-notifications.component';
import { EditEmailNotificationComponent } from './main/pages/notification-contents/email-notifications/edit-email-notification/edit-email-notification.component';
import { EditPushNotificationComponent } from './main/pages/notification-contents/push-notifications/edit-push-notification/edit-push-notification.component';
import { EditSystemNotificationComponent } from './main/pages/notification-contents/system-notifications/edit-system-notification/edit-system-notification.component';
import { ConsultationComponent } from './main/pages/consultation/consultation.component';
import { ConclusionOptionsListComponent } from './main/pages/conclusion-options/conclusion-options-list/conclusion-options-list.component';
import { CreateEditConclusionOptionComponent } from './main/pages/conclusion-options/create-edit-conclusion-option/create-edit-conclusion-option.component';
import { SurveyListComponent } from './main/pages/surveys/survey-list/survey-list.component';
import { CreateEditSurveyComponent } from './main/pages/surveys/create-edit-survey/create-edit-survey.component';
import { BranchListComponent } from './main/pages/organizations/branch-list/branch-list.component';
import { CreateEditBranchComponent } from './main/pages/organizations/create-edit-branch/create-edit-branch.component';
import { AnalysisReportListComponent } from './main/pages/analysis-report-list/analysis-report-list.component';
import { PatientReportListComponent } from './main/pages/patient-report-list/patient-report-list.component';
import { DoctorReportListComponent } from './main/pages/doctor-report-list/doctor-report-list.component';
import { InformationSetupComponent } from './main/pages/information-setup/information-setup.component';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'main', component: DashboarMainComponent },
      { path: '**', redirectTo: 'main' },
    ],
  },
  {
    path: 'user',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: UserListComponent },
      { path: 'create', component: CreateEditUserComponent },
      { path: 'edit/:id', component: CreateEditUserComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'organization',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: OrganizationListComponent },
      { path: 'create', component: CreateEditOrganizationComponent },
      { path: 'edit/:id', component: CreateEditOrganizationComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'branch',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: BranchListComponent },
      { path: 'create', component: CreateEditBranchComponent },
      { path: 'edit/:id', component: CreateEditBranchComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'notification-contents',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'push', component: PushNotificationsComponent },
      { path: 'push/edit/:id', component: EditPushNotificationComponent },
      { path: 'email', component: EmailNotificationsComponent },
      { path: 'email/edit/:id', component: EditEmailNotificationComponent },
      { path: 'system', component: SystemNotificationsComponent },
      { path: 'system/edit/:id', component: EditSystemNotificationComponent },
    ],
  },
  {
    path: 'conclusion-options',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: ConclusionOptionsListComponent },
      { path: 'create/:code', component: CreateEditConclusionOptionComponent },
      { path: 'add/:app/:id', component: CreateEditConclusionOptionComponent },
      { path: 'edit/:id', component: CreateEditConclusionOptionComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'survey',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: SurveyListComponent },
      { path: 'create/:code', component: CreateEditSurveyComponent },
      { path: 'add/:app/:id', component: CreateEditSurveyComponent },
      { path: 'edit/:id', component: CreateEditSurveyComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'report',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'analysis-report', component: AnalysisReportListComponent },
      { path: 'patient-report', component: PatientReportListComponent },
      { path: 'doctor-report', component: DoctorReportListComponent },
    ],
  },
  {
    path: 'information-setup',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: InformationSetupComponent },
    ],
  },
];
